import React, { useState, useEffect, useCallback } from "react";
import { Grid, Dialog, Slide } from "@material-ui/core/";
import Alert from "react-s-alert";
/********** COMPONENTS **********/
import LoadingSpinner from "component/LoadingSpinner";
import AlertElement from "component/AlertElement";
import Title from "component/Title";
import Table from "component/Table";
/********** SERVICES **********/
import ApiServices from "service/ApiServices";
/********** STYLES **********/
import { useStyles } from "./style";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide(props) {
  /********** VARIABLES **********/
  const classes = useStyles();
  const controller = "detalleHojaAfiliacionAdhesion";
  const [elementAlertModal, setElementAlertModal] = useState({
      openAlert: false,
      titleAlert: "",
      typeAlert: "",
    }),
    [loadingSpinner, setLoadingSpinner] = useState({
      openLoading: false,
      message: "",
    }),
    [data, setData] = useState([]),
    [tableOptions] = useState({
      pageSize: 10,
      pageSizeOptions: [10, 20],
      toolbar: true,
      paging: true,
      search: false,
      actionsColumnIndex: -1,
    }),
    [tableHeader] = useState([
      {
        title: "No. de línea",
        field: "noLinea",
        cellStyle: { width: "200px", height: "40px" },
      },
      { title: "Código Único de Identificación", field: "cui" },
      { title: "Fecha de afiliación", field: "fechaAfiliacionSimple" },
      { title: "Primer nombre", field: "primerNombre" },
      { title: "Segundo nombre", field: "segundoNombre" },
      { title: "Primer apellido", field: "primerApellido" },
      { title: "Segundo apellido", field: "segundoApellido" },
    ]);

  /********** FUNCTIONS **********/
  const showList = useCallback(async () => {
    try {
      setLoadingSpinner({
        ...loadingSpinner,
        openLoading: true,
        message: "Obteniendo detalle del paquete...",
      });
      const hasPermission = await ApiServices.userSecurity.hasPermission(
        controller,
        "list"
      );
      if (hasPermission.error) {
        setElementAlertModal({
          titleAlert: "Permisos Insuficientes",
          typeAlert: "error",
          openAlert: true,
        });
        setLoadingSpinner({ ...loadingSpinner, openLoading: false });
      } else {
        let response = await ApiServices[controller].getDetalleHoja(
          props.data.idHoja
        );
        if (response.error !== null) {
          setElementAlertModal({
            openAlert: true,
            titleAlert: response.error.message,
            typeAlert: "error",
          });
        } else if (response.data !== "") {
          let newData = response.data;
          newData.sort((a, b) => (a.noLinea > b.noLinea ? 1 : -1));
          setData(newData);
        }
        setLoadingSpinner({ ...loadingSpinner, openLoading: false });
      }
    } catch (exception) {
      exception.status === 404
        ? Alert.warning("Intente de nuevo")
        : Alert.warning("Intente de nuevo ");
      setLoadingSpinner({ ...loadingSpinner, openLoading: false });
    }
  }, []);

  useEffect(() => {
    showList();
  }, [showList]);

  /*  Este método cierra el modal actual, se ejecuta desde el bóton "Cerrar" o al presionar fuera del modal */
  const closeModal = () => {
    props.handCloseModal();
  };

  /* Este método cierra el modal "AlertElement" de mensajes de alerta */
  const handleCloseAlertModal = () => {
    setElementAlertModal({ ...elementAlertModal, openAlert: false });
  };

  /********** RENDER **********/
  return (
    <div>
      <Dialog
        open={props.open}
        maxWidth={"xl"}
        fullWidth={true}
        fullScreen={true}
        TransitionComponent={Transition}
        keepMounted
        onClose={closeModal}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        {loadingSpinner.openLoading && (
          <LoadingSpinner
            open={loadingSpinner.openLoading}
            message={loadingSpinner.message}
          />
        )}
        {elementAlertModal.openAlert && (
          <AlertElement
            typeAlert={elementAlertModal.typeAlert}
            openModal={elementAlertModal.openAlert}
            title={elementAlertModal.titleAlert}
            handCloseModal={handleCloseAlertModal}
          />
        )}
        <Title title={"Detalle de registros en la hoja "} />
        <div className={classes.root}>
          <div className={classes.colorComponente}>
            <Grid container>
              <Grid className={classes.AlignTable} item xs={12}>
                <Table
                  title={"Listado de ciudadanos"}
                  header={tableHeader}
                  data={data}
                  goBack={closeModal}
                  options={tableOptions}
                />
              </Grid>
            </Grid>
            <br />
            <div className={classes.lineaDegradadaBottom}></div>
          </div>
          <br />
        </div>
      </Dialog>
    </div>
  );
}
